module.exports = __webpack_public_path__ + "static/img/intermedio1.b40a6615.jpg";